import {
  Section,
  ReadOnlyField,
  Stack,
} from '@fashionnovateam/nova-ui-toolkit';
import { VendorCatalogItem } from '../../../../Lib/Hooks/ItemService';

type NotesSectionProps = {
  item: VendorCatalogItem | undefined;
};

function NotesSection({ item }: NotesSectionProps) {
  return (
    <Section
      icon="chat/chat-default"
      title="Notes"
      color="neutral"
      containerClassNames="!items-start !flex-1 !flex-col"
      className="flex-1 !flex !flex-col"
      iconVariant="solid"
      separateHeader={false}
      withoutShadow
      withoutBorder
      iconColor="black"
      data-testid="notes-readonly-section"
    >
      <Stack direction="col" className="gap-3">
        <Stack direction="row" className="gap-0.5">
          <ReadOnlyField
            className="flex-1"
            label="Vendor Notes"
            value={item?.vendor_notes}
            id="vendor-notes"
          />
        </Stack>
      </Stack>
    </Section>
  );
}

export default NotesSection;
